import React, { useEffect } from "react";
import "../../styles/ProvHome.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListCheck,
  faBookOpen,
  faFile,
  faFileImport,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function NLMain({ setProvince }) {
  const scrollTop = (e) => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setProvince("NL");
  });

  return (
    <div className="home-wrapper  w-full relative">
      <div className="home-pic relative">
        <img src="../../images/txnguide-picture.png" alt="home-pic" />
        <div className="x-pic absolute bottom-0 right-0 ">
          <img src="../../images/exp-x.png" alt="x-pic" />
        </div>
      </div>

      <br />

      <div className="flex flex-wrap justify-center pt-2">
        <div className="px-2">
          <Link
            to="/NL/transaction-checklists"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center ">
                <FontAwesomeIcon
                  icon={faListCheck}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex flex-col leading-none w-full justify-center items-center mt-1">
                Transaction
                <div>Checklists</div>
              </div>
            </div>
          </Link>
        </div>

        <div className="px-2">
          <Link
            to="/NL/common-forms"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center  ">
                <FontAwesomeIcon
                  icon={faFile}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex justify-center mt-3">Common Forms</div>
            </div>
          </Link>
        </div>
        <div className="px-2">
          <Link
            to="/NL/transaction-best-practices"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center ">
                <FontAwesomeIcon
                  icon={faBookOpen}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex flex-col leading-none w-full justify-center items-center mt-1">
                Transaction
                <div>Best Practices</div>
              </div>
            </div>
          </Link>
        </div>

        <div className="px-2">
          <Link
            to="/NL/office-procedures"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center  ">
                <FontAwesomeIcon
                  icon={faFileImport}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex justify-center mt-3">Office Procedures</div>
            </div>
          </Link>
        </div>
      </div>

      <div className="w-full pt-2"></div>
      <p>
        eXp Realty has compiled these checklists as general guidance on common
        residential real estate transactions and are not intended to be a
        comprehensive list. Each deal is unique, so the responsibility is on
        every eXp Realty REALTOR® to perform proper due diligence as part of
        their legal obligation to provide competent service.
      </p>
      <br />
      <p>
        OREA form revisions are made at the outset of each year, and we are
        legally required to be familiar with the contents and use the current
        forms/clauses.
      </p>
      <br />
      <br />
      <h1>Message from your Newfoundland Managing Broker Team </h1>
      <br />
      <p>
        We are here to help and love doing so! If you have questions or require
        assistance with any of your transactions, please feel free to reach out
        to your Managing Brokers. We look forward to assisting you so that you
        feel confident in your business and your transactions run smoothly.
      </p>
    </div>
  );
}
